import React, { lazy, Suspense } from 'react'
import Loader from 'components/Reusable/Loader'

const Home = lazy(() => import('components/Sections/Home'))
const Footer = lazy(() => import('components/Layout/Footer'))

function HomePage() {
    const loader = () => <Loader />

    const MainComponent = () => (
        <Suspense fallback={loader()}>
            <Home />
            <Footer />
        </Suspense>
    )

    return MainComponent()
}

export default HomePage